// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3NNSY","rootSuccess":"CompleteLink_rootSuccess__mQeXv","rootFailure":"CompleteLink_rootFailure__1pJpE","isDisabled":"CompleteLink_isDisabled__UD76H"};